<template>
    <div class="mfa-setup-banner text-center px-2 py-hf" v-if="setup" data-test="mfa-setup-banner">
        Two-step verification will be required for your account from {{ deadline }}.<template v-if="native"> Set it up on a computer at getmypaystub.com.</template>
        <router-link v-else :to="{name: 'account'}" class="btn btn-link btn-sm py-0 ml-1 align-baseline" data-test="mfa-setup-banner-link">Set it up</router-link>
    </div>
</template>

<script>
import { formatDeadline } from '@/mfa-deadline'
import { isNativeHost } from '@/native-bridge'

// Shown to a required user who hasn't set up MFA, until their deadline.
// After it, the setup page takes over (navigation-guard.js).
export default {
    data() {
        return {
            native: isNativeHost(),
        }
    },
    computed: {
        setup() {
            const user = this.$store.state.user
            const setup = user && user.mfa_setup
            return setup && !setup.enforced ? setup : null
        },
        deadline() {
            return formatDeadline(this.setup.deadline)
        },
    },
}
</script>

<style scoped>
.mfa-setup-banner {
    background: #fff3cd;
    color: #664d03;
    border-bottom: 1px solid #ffe69c;
}
</style>
